import React, { useCallback, useEffect, useState } from 'react';
import { registerClass } from '@food/css-manager/build/dist';
import { Modal } from '@food/ui/build/dist/src/Modal2';
import { setLocalAchievement } from '../utils/misc';
import { useTranslation } from 'react-i18next';
import { generateTypeformUrl } from '../utils/urls';
import { isLogged } from '@food/auth/build/dist/logic/auth';
import { client } from './apps/NewsStand';
import { saveAchievementMutation } from '../utils/achievements';

export interface TypeformModalFormProps {
	achievement: string; // della forma typeform:XXX
	onSubmit: () => void; // la callback da eseguire una volta compilato il form!
	children: (modalSetter: (open: boolean) => void) => JSX.Element; // il figlio che avra' il controllo dello stato
}

const iframeClass = registerClass(
	() => `
	width:100%;
	min-height: 50vh;
`,
);

export const TypeformModalForm: React.FC<TypeformModalFormProps> = ({
	achievement,
	onSubmit,
	children,
}) => {
	const [modalOpen, setModalOpen] = useState<boolean>(false);
	const { t } = useTranslation();

	const typeformId = achievement.replace('typeform:', '');

	const callback = useCallback(
		(event) => {
			if (
				event.origin === 'https://gruppofood.typeform.com' &&
				event.data.type === 'form-submit'
			) {
				setModalOpen(false);
				setLocalAchievement(achievement);
				if (isLogged()) {
					client.mutate({
						mutation: saveAchievementMutation,
						variables: { achievement },
					});
				}
				onSubmit();
			}
		},
		[achievement, onSubmit],
	);

	useEffect(() => {
		window.addEventListener('message', callback);
		return () => {
			window.removeEventListener('message', callback);
		};
	}, [callback]);

	return (
		<>
			<Modal open={modalOpen} closeHandler={() => setModalOpen(false)}>
				{() => (
					<iframe
						title={t`typescript form frame`}
						className={iframeClass}
						src={generateTypeformUrl(typeformId, achievement)}
					/>
				)}
			</Modal>
			{children(setModalOpen)}
		</>
	);
};
